<script>
import { getProducts } from "@/api/static";
import { mapActions, mapGetters } from "vuex";
import TM from "@/api/ticket-management";
import padLeft from "@/vendor/padLeft";

const culturePointDomain = process.env.VUE_APP_MOC_DOMAIN;
const culturePointUrl = process.env.VUE_APP_MOC_WEB_URL;
const marketCd = process.env.VUE_APP_MARKET_CD;
window.couponWin = null;

export default {
  data() {
    return {
      reserveData: null,
      isCanceling: false,
      isCanceled: false,
      hasPostMessage: false
    };
  },
  computed: {
    ...mapGetters({
      event: "event/campaign",
      useCulturePoint: "culturePoint/useCulturePoint",
      culturePointResponse: "culturePoint/culturePointResponse"
    })
  },
  watch: {
    useCulturePoint(newVal, old) {
      if (this.isOrderSuccessed) return;
      if (newVal !== old) {
        this.culturePointUsage = newVal;
        if (newVal) this.setCulturePoint(newVal);
        else this.cancelCulturePoint();
      }
    }
  },
  methods: {
    ...mapActions({
      showDialog: "dialog/show",
      doUpdateOrder: "order/updateOrder",
      reserveTicket: "order/reserveTicket",
      resetCulturePoint: "culturePoint/resetCulturePoint",
      closeDialog: "dialog/close",
      use: "culturePoint/use"
    }),
    disableMessage() {
      window.removeEventListener(
        "message",
        this.receiveCulturePointMessage,
        false
      );
    },
    async cancelCulturePoint(isPreStep, PreStepFn) {
      if (this.isCanceling || this.isCanceled) return;
      this.isCanceling = true;
      if (this.countdown <= 0) {
        this.resetCulturePoint();
        this.disableMessage();
      } else {
        const { data: updateResponse } = await TM.ticketUpdate({
          orderId: this.reserveResponse.orderId,
          culturePointInfo: {}
        });

        if (updateResponse.errCode !== "00") {
          this.showDialog(
            updateResponse.errCode == "122"
              ? {
                  title: "更新失敗",
                  content: "文化幣平台無回應, 請稍後再試"
                }
              : {
                  title: "取消失敗",
                  content: "文化幣取消綁定失敗，請再試一次"
                }
          );
          setTimeout(() => {
            this.closeDialog();
          }, 3000);
        } else {
          this.isCanceled = true;
          this.doUpdateOrder(updateResponse);
          this.resetCulturePoint();
          this.disableMessage();

          if (isPreStep) PreStepFn();
        }
        this.isCanceling = false;
      }
      this.$forceUpdate();
    },
    async setCulturePoint() {
      // 前往票券平台
      this.loadingOverlay = true;
      window.addEventListener(
        "message",
        this.receiveCulturePointMessage,
        false
      );
      window.couponWin = window.open(
        `${culturePointUrl}/page/confirm-order?marketCd=${marketCd}`,
        "CulturePointWindow"
      );

      const $this = this;
      this.detectCloseInterval = setInterval(() => {
        if (
          window.couponWin &&
          window.couponWin.closed &&
          !$this.hasPostMessage
        ) {
          clearInterval($this.detectCloseInterval);
          $this.disableMessage();
          $this.loadingOverlay = false;
          if (
            !$this.updateResponse ||
            !$this.updateResponse.culturePointDeductAmount
          ) {
            $this.resetCulturePoint();
          }
        }
      }, 5000);
    },
    async initTickets(updateData) {
      const $this = this;
      if (this.areaAssignment && this.seatAssignment) {
        let { data: prodData } = await getProducts(this.$route.params.eventId);
        const seats = this.reserveResponse.products.reduce(
          (accr, reserve, index) => {
            let seats = reserve.seats.reduce((ary, seat, seatIdx) => {
              let product = prodData.products.find(
                p => p.productId === reserve.id
              );
              let newSeat = {
                ...seat,
                ...product,
                idx: reserve.idx,
                price: reserve.price,
                productId: reserve.productId
              };

              ary.push(newSeat);
              return ary;
            }, []);
            accr = accr.concat(seats);
            return accr;
          },
          []
        );

        this.reserveTickets = seats.map((seat, i) => {
          let ticket = $this.tickets.find(t => t.productId === seat.productId);

          return {
            ...seat,
            ...ticket
          };
        });
      } else {
        this.reserveTickets = this.reserveResponse.products.reduce(
          (accr, reserve, index) => {
            let selectedTicket = $this.tickets.find(
              t => t.productId === reserve.productId
            );

            let newTicket = {
              ...reserve,
              ...selectedTicket
            };
            if (
              !!updateData &&
              updateData.products[index].culturePointProductInfos
            ) {
              newTicket.culturePointProductInfos =
                updateData.products[index].culturePointProductInfos;
            }

            accr.push(newTicket);
            return accr;
          },
          []
        );
        this.$forceUpdate();
      }
      this.reserveTicket({
        ...this.reserveResponse,
        culturePointDeductAmount: updateData.culturePointDeductAmount,
        tickets: this.reserveTickets,
        total: updateData.total
      });
    },
    async receiveCulturePointMessage(e) {
      if (
        !this.reserveData ||
        this.reserveData.orderId !== this.reserveResponse.orderId ||
        e.data.id === "patterns" ||
        e.data.id === "js" ||
        e.origin !== culturePointDomain
      ) {
        return;
      }
      let data = typeof e.data === "object" ? e.data : JSON.parse(e.data);

      if (!!data.code) {
        if (data.code === "0000") {
          let tickets = this.reserveResponse.products.reduce(
            (accr, prod, index) => {
              let ticketList = [];
              let product = this.productData.find(
                p => p.productId === prod.productId
              );
              let isEn = this.sessionInfo.address.indexOf(",") > -1;
              let area = "";
              if (
                this.sessionInfo.sessionCity &&
                this.sessionInfo.sessionCity !== ""
              ) {
                area = this.sessionInfo.sessionCity;
              } else {
                let areaStr = !isEn ? this.sessionInfo.address.slice(2, 3) : "";
                let address = isEn
                  ? this.sessionInfo.address.indexOf(/,/g)
                  : this.sessionInfo.address.split(/\市|\縣/);
                area = address[0] + areaStr;
              }

              if (isEn) {
                address.reverse();
              }
              for (let i = 0; i < prod.count; i++) {
                ticketList.push({
                  seqNo: `${padLeft("0" + prod.idx, 10)}T${padLeft(
                    "0" + (i + 1),
                    5
                  )}`,
                  type: this.event.culturePointType,
                  eventHall: this.sessionInfo.location,
                  name: this.sessionInfo.name,
                  specification: `${product.name}_${prod.count}`,
                  area: area,
                  productAmount: product.price
                });
              }
              accr = accr.concat(ticketList);
              return accr;
            },
            []
          );

          let couponData = {
            marketCd: marketCd,
            orderNo: this.reserveResponse.orderId + "",
            amount: this.reserveResponse.total,
            productInfos: tickets
          };
          // let couponDataString = JSON.stringify(couponData);

          window.couponWin.postMessage(couponData, "*");
        } else if (data.code === "9999") {
          this.use(false);
        }
      }

      if (!!data.mergeTransactionId) {
        this.hasPostMessage = true;
        this.$forceUpdate();
        const { data: updateResponse } = await TM.ticketUpdate({
          orderId: this.reserveResponse.orderId,
          culturePointInfo: {
            mergeTransactionId: data.mergeTransactionId,
            productInfos: data.productInfos
          }
        });

        if (updateResponse.errCode == "00") {
          this.disableMessage();
          this.updateOrder({
            ...updateResponse,
            products: updateResponse.products.map(prod => {
              let product = this.productData.find(
                p => p.productId === prod.productId
              );
              return {
                ...prod,
                ...product
              };
            })
          });
          this.$forceUpdate();
          this.reserveTickets = [...this.reserveResponse.tickets];
          this.loadingOverlay = false;
          this.hasPostMessage = false;
          this.isCanceled = false;
        } else {
          this.showDialog(
            updateResponse.errCode == "122"
              ? {
                  error: true,
                  title: "更新失敗",
                  content: "文化幣平台無回應, 請稍後再試",
                  buttons: this.$t("order_step_1_reserve_dialog_cta")
                }
              : {
                  error: true,
                  title: "更新失敗",
                  content: "文化幣更新失敗，請再試一次",
                  buttons: this.$t("order_step_1_reserve_dialog_cta")
                }
          );
          this.hasPostMessage = false;
        }
      }
    }
  }
};
</script>
